export default __webpack_public_path__ + "images/DynamicsNav2019BusinessCentral.svg";